export default __webpack_public_path__ + "static/assets/aea543a1fc5d2f4f0eaa17c6f98f59a4.svg";